import { useQuery } from "@tanstack/react-query";
import { attemptFetchResetTokenInfo } from '../../api/AuthApi';

// Hook to check whether a password reset token is valid, expired, deleted, or missing.
// Usage: const { data, status, error, isFetching, refetch } = useCheckResetToken(token);
export const useCheckResetToken = (token, options = {}) => {
  return useQuery({
    queryKey: ["check-reset-token", token],
    queryFn: () => attemptFetchResetTokenInfo(token),
    enabled: !!token,
    retry: false,
    ...options,
  });
};
